import { render } from "./SpecialAccountManagement.vue?vue&type=template&id=0bd4b0e5&scoped=true"
import script from "./SpecialAccountManagement.vue?vue&type=script&lang=js"
export * from "./SpecialAccountManagement.vue?vue&type=script&lang=js"

import "./SpecialAccountManagement.vue?vue&type=style&index=0&id=0bd4b0e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd4b0e5"],['__file',"src/views/SpecialAccountManagement/SpecialAccountManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bd4b0e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bd4b0e5', __exports__)) {
    api.reload('0bd4b0e5', __exports__)
  }
  
  module.hot.accept("./SpecialAccountManagement.vue?vue&type=template&id=0bd4b0e5&scoped=true", () => {
    api.rerender('0bd4b0e5', render)
  })

}


export default __exports__